/* 
    @param {Object} product - The product object
    @returns {String} - The product finder url
    @vehicle_subtype (String) - The car subtype (generic, truck, van, etc)
    @vehicle_type (String) - The car type (car, boat, utv, atv etc)
*/

const generateProductFinderUrl = (product) => {
    if (product?.vehicle_subtype && product?.vehicle_subtype !== "generic") return `/pages/${product.vehicle_subtype.replace("_", "")}-covers`;
    
    if (product?.vehicle_type) return `/pages/${product?.vehicle_type.replace("_", "")}-covers`;

    return "/";
};

export default generateProductFinderUrl;
